import React, { useState, createContext, useMemo } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

// components
import CardTitle from 'page_modules/business-vac/components/CardTileDesktop/Components/CardTitle';
import AnnualFee from 'page_modules/business-vac/components/CardTileDesktop/Components/AnnualFee';
import OfferBox from './OfferBox';
import CardBenefits from './CollapsibleBenefits';
import Tncs from 'page_modules/business-vac/components/CardTileDesktop/Components/Tncs';
import ApplyNowCta from 'page_modules/business-vac/components/CardTileDesktop/Components/ApplyNowCta';
import LearnMoreCta from 'page_modules/business-vac/components/CardTileDesktop/Components/LearnMoreCta';
import UpgradeCta from 'page_modules/business-vac/components/CardTileDesktop/Components/UpgradeCta';
import CardArt from 'page_modules/business-vac/components/CardTileDesktop/Components/CardArt';
import AdditionalUpgradeText from 'page_modules/business-vac/components/CardTileDesktop/Components/AdditionalUpgradeText';
import AddEmployeeCta from 'page_modules/business-vac/components/CardTileDesktop/Components/AddAnEmployeeCta';
import ColorPicker, { parent } from 'src/universal/components/ColorPicker';
import CheckboxCompareButton from 'src/universal/components/CheckboxCompareButton';
import Ribbon, {
  POSITIONS
} from 'page_modules/business-vac/components/CardTileDesktop/Components/Ribbon';
import { Icon } from '@americanexpress/aqx-components';
import YourCardBadge from 'src/universal/components/YourCardBadge';
import AmazonDisclaimer from 'page_modules/business-vac/components/AmazonDisclaimer';
import { makeGetExtendedTilesData } from '../redux';
import {
  makeGetCardTitle,
  makeGetIsTier1Offer
} from 'page_modules/business-vac/components/CardTileDesktop/redux';
import styles from '../__styles__/Desktop.scss?modules';

export const G172QuickViewContext = createContext(null);

const Tile = ({ shortName, cardTitle, isTier1Offer, cardTileData }) => {
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);
  const contextValue = useMemo(() => ({ isQuickViewOpen, setIsQuickViewOpen }), [
    isQuickViewOpen,
    setIsQuickViewOpen
  ]);

  const benefitsHeader = cardTileData?.benefitsHeader || '';
  return (
    <G172QuickViewContext.Provider value={contextValue}>
      <div className={styles.g172DesktopContainer}>
        <div
          className={isTier1Offer ? styles.tier1TileContainer : styles.tileContainer}
        >
          <Ribbon position={POSITIONS.TILE_RIBBON} shortName={shortName} />
          <div className={styles.cardTileRow}>
            <div
              className={clsx(styles.cardCol, {
                [styles.tier1Tile]: isTier1Offer
              })}
            >
              <div className={styles.cardContent}>
                <CardArt shortName={shortName} />
                <ColorPicker shortName={shortName} parentType={parent.VAC_TILE} />
                <UpgradeCta shortName={shortName} />
                <ApplyNowCta shortName={shortName} />
                <AdditionalUpgradeText shortName={shortName} />
                <LearnMoreCta shortName={shortName} />
                <CheckboxCompareButton cardTitle={cardTitle} shortName={shortName} />
                <AddEmployeeCta shortName={shortName} />
                <Tncs shortName={shortName} />
              </div>
            </div>
            <div
              className={clsx(styles.contentCol, {
                [styles.tier1Tile]: isTier1Offer
              })}
            >
              <div className={styles.contentContainer}>
                <div className={styles.cardTileWrapper}>
                  <CardTitle shortName={shortName} />
                  <Icon
                    className={styles.cardNameArrow}
                    directory="dls"
                    imageName={`dls-icon-right`}
                    theme={{
                      marginLeft: 10
                    }}
                  />
                </div>
                <YourCardBadge shortName={shortName} />
                <AnnualFee shortName={shortName} />
                <div className={clsx(styles.benefitContent, styles.varB)}>
                  <div
                    className={clsx(styles.offerWrapper, {
                      [styles.tier1Tile]: isTier1Offer
                    })}
                  >
                    <OfferBox shortName={shortName} />
                    <AmazonDisclaimer shortName={shortName} />
                  </div>
                  <div
                    className={clsx(styles.benefitsWrapper, {
                      [styles.tier1Tile]: isTier1Offer
                    })}
                  >
                    <CardBenefits shortName={shortName} header={benefitsHeader} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </G172QuickViewContext.Provider>
  );
};

const mapStateToProps = () => {
  const getCardTitle = makeGetCardTitle();
  const getIsTier1Offer = makeGetIsTier1Offer();
  const getCardTileData = makeGetExtendedTilesData();

  return (state, { shortName }) => {
    return {
      cardTitle: getCardTitle(state, shortName),
      isTier1Offer: getIsTier1Offer(state, shortName),
      cardTileData: getCardTileData(state)
    };
  };
};

export default connect(mapStateToProps)(Tile);
